module.exports = __webpack_public_path__ + "img/ecg_white_new.c542e1b1.png";